import React from "react";
import "../../Assets/Css/DiagnosticSkip.css";

// Import SVG icons as images
import closeIcon from "../../Assets/Images/SVG/cross1.svg";
import calendarIcon from "../../Assets/Images/SVG/testlog-calendar.svg";
import diagnosticIcon from "../../Assets/Images/SVG/DiaSnooze.svg";

const DiagnosticSkip = ({ onClose, onSetDate, onSkip }) => {
  return (
    <div className="dspopup-overlay">
      <div className="dspopup-container">
        <button className="dsclose-btn" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
        <div className="dspopup-content">
          <div className="dsicon-wrapper">
            <img src={diagnosticIcon} alt="Diagnostic Icon" />
          </div>
          <h3 className="dspopup-title">Diagnostics</h3>
          <div className="dspopup-actions">
            <button className="dsskip-btn" onClick={onSkip}>
              Skip
            </button>
            <button className="dsset-date-btn" onClick={onSetDate}>
              Set date <img src={calendarIcon} alt="Calendar Icon" className="dscalendar-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticSkip;
